import { render } from "./Brush.vue?vue&type=template&id=2998b0de"
import script from "./Brush.vue?vue&type=script&lang=js"
export * from "./Brush.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__